import Router from 'awcf/Router';
import { onAuthChanged, signOutUser } from './firebase/auth.js';
import './style.css';

const main = () => {
  const root = document.getElementById('root');
  const loaderText = root.querySelector('.loader-text');
  let router;

  loaderText.textContent = 'Checking authentication...';

  onAuthChanged(async (user) => {
    if (!user) {
      import('./components/SignIn').then(({ default: SignIn }) => {
        router = null;
        root.innerHTML = '';
        root.appendChild(new SignIn());
      });
      return;
    }

    if (!user.claims?.admin && !user.memberships?.length) {
      router = null;
      root.innerHTML = '';
      root.appendChild(Object.assign(document.createElement('div'), {
        className: 'backdrop',
        textContent: 'Access denied.',
      }));
      return;
    }

    const state = {
      user,
    };

    if (!router) {
      const routes = await import('./routes').then(m => m.default);
      const AppBar = await import('./components/AppBar').then(m => m.default);

      router = new Router(routes, state);
      router.prepend(new AppBar(state));

      root.innerHTML = '';
      root.appendChild(router);
      return;
    }

    router.setState(state);
  });
};

window.addEventListener('load', main);
